import { Link } from 'react-router-dom';
import { SELLER } from './sellerInfo';
import { setSeoMeta, toAbsoluteUrl, upsertJsonLd, removeJsonLd } from '../../utils/seo';
import { useEffect } from 'react';

export default function Contacts() {
  const s = SELLER;

  useEffect(() => {
    const canonical = toAbsoluteUrl('/contacts');
    setSeoMeta({
      title: `Контакты и реквизиты — ${s.brand}`,
      description: `${s.name}, ИНН ${s.inn}. Телефон ${s.phoneDisplay}, ${s.address}.`,
      canonical,
      og: {
        type: 'website',
        title: `Контакты — ${s.brand}`,
        description: `${s.name}. ${s.phoneDisplay}`,
        url: canonical,
      },
    });

    upsertJsonLd('org-contacts', {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: s.brand,
      legalName: s.name,
      url: s.site,
      email: s.email,
      telephone: s.phoneTel,
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'ул. Красных Партизан/им. Котовского, 489/103',
        addressLocality: 'Краснодар',
        addressCountry: 'RU',
      },
    });

    return () => removeJsonLd('org-contacts');
  }, [s]);

  return (
    <div className="container page" style={{ textAlign: 'left' }}>
      <h1>Контакты и реквизиты</h1>

      <p>
        Интернет‑магазин сантехники <strong>{s.brand}</strong>. Ниже — сведения о продавце,
        обязательные для информирования потребителя.
      </p>

      <section>
        <h2>Продавец</h2>
        <dl className="legal-dl">
          <div>
            <dt>Наименование</dt>
            <dd>{s.name}</dd>
          </div>
          <div>
            <dt>ИНН</dt>
            <dd>{s.inn}</dd>
          </div>
          <div>
            <dt>ОГРНИП</dt>
            <dd>{s.ogrnip}</dd>
          </div>
          <div>
            <dt>Адрес</dt>
            <dd>{s.address}</dd>
          </div>
          <div>
            <dt>Телефон</dt>
            <dd>
              <a href={`tel:${s.phoneTel}`}>{s.phoneDisplay}</a>
            </dd>
          </div>
          <div>
            <dt>E‑mail</dt>
            <dd>
              <a href={`mailto:${s.email}`}>{s.email}</a>
            </dd>
          </div>
          <div>
            <dt>Режим работы</dt>
            <dd>{s.hours}</dd>
          </div>
        </dl>
      </section>

      <section>
        <h2>Документы</h2>
        <ul>
          <li>
            <Link to="/oferta">Публичная оферта</Link>
          </li>
          <li>
            <Link to="/privacy">Политика конфиденциальности</Link>
          </li>
          <li>
            <Link to="/delivery">Доставка и возврат</Link>
          </li>
          <li>
            <Link to="/return-memo">Памятка о возврате</Link>
          </li>
        </ul>
      </section>

      <section>
        <h2>Оплата</h2>
        <p>
          Онлайн‑оплата через защищённую форму Т‑Банка. Данные банковских карт на сайте не
          хранятся. Кассовый чек направляется на телефон и/или e‑mail, указанные при заказе.
        </p>
      </section>

      <style>{`
        .legal-dl { display: grid; gap: 12px; margin: 16px 0 24px; }
        .legal-dl > div { display: grid; grid-template-columns: 140px 1fr; gap: 8px; }
        .legal-dl dt { opacity: 0.7; margin: 0; }
        .legal-dl dd { margin: 0; }
        @media (max-width: 560px) {
          .legal-dl > div { grid-template-columns: 1fr; }
        }
      `}</style>

      <p style={{ opacity: 0.8, marginTop: 24 }}>
        © {new Date().getFullYear()} {s.name}. Последнее обновление: {s.updatedAt}
      </p>
    </div>
  );
}
